import { cloneDeep } from 'lodash'

export default {
  toolsPanel_toggle(state, isOpened) {
    state.toolsPanel_isOpened = isOpened
  },
  toolsPanel_setItem(state, { id, payload }) {
    if (!state.toolsPanel_itemsDescription[id]) {
      throw new Error(`Tools Panle item [${id}] not found`)
    }

    state.toolsPanel_isOpened = true
    state.toolsPanel_visibleItem = id

    let itemData = {
      ...state.toolsPanel_itemsDescription[id],
    }

    if (payload) itemData = Object.assign(itemData, { ...payload })

    const newDesc = cloneDeep(Object.assign(state.toolsPanel_openedItemsDescription, {
      [id]: itemData,
    }))

    state.toolsPanel_openedItemsDescription = newDesc
  },
  toolsPanel_release(state) {
    state.toolsPanel_openedItemsDescription = {}
  }
}
